import wpAjax from "../helpers/axios";
import { openPopup } from "../helpers/popups";

const initFooterNewsletterForm = () => {
  const form = document.querySelector(".js-footer-newsletter");
  form.addEventListener("submit", (e) => {
    e.preventDefault();
    const formData = new FormData(form);

    for (const pair of formData.entries()) {
      //   console.log(`${pair[0]} = ${pair[1]}`);
      if (pair[0] == "email" && pair[1]) {
        document
          .querySelectorAll(".js-newsletter-email-field")
          .forEach((field) => (field.value = pair[1]));
      }
      if (pair[0] == "opt_in") {
        document
          .querySelectorAll(".js-newsletter-optin")
          .forEach((checkbox) => (checkbox.checked = true));
      }
    }

    openPopup("newsletter");
  });
};

const initNewsletterForms = () => {
  const forms = document.querySelectorAll(".js-newsletter-form");

  if (forms.length >= 1) {
    forms.forEach((form) => {
      form.addEventListener("submit", async (e) => {
        e.preventDefault();

        const res = await submitNewsletterForm(form);
        const messageEl = form.querySelector(".c-form__message");

        // show a success or error message
        if (res.status === "error") {
          let message =
            res.errors?.[0]?.cause?.[0]?.message ||
            "There was an error signing you up. Please check your network and try again later.";

          // Remove strange capitalisation from Como error messages
          message =
            message.charAt(0).toUpperCase() + message.slice(1).toLowerCase();

          messageEl.innerHTML = `Error: ${message}`;
        } else if (res.status === "ok") {
          messageEl.innerHTML = "Thanks for signing up.";
        }

        form.classList.remove("submitting");
        messageEl.style.display = "block";
      });
    });
  }
};

const submitNewsletterForm = async (form) => {
  form.classList.add("submitting");
  const messageEl = form.querySelector(".c-form__message");

  // Reset error messages
  messageEl.innerHTML = "";
  messageEl.style.display = "none";

  // Get data for ajax
  const formData = new FormData(form);
  formData.append("action", "ajax_submit_newsletter_form");

  // Debug form values
  //   for (const pair of formData.entries()) {
  //     console.log(`${pair[0]} = ${pair[1]}`);
  //   }

  try {
    const { data } = await wpAjax.post("", formData);

    return data;
  } catch (err) {
    console.error(err);
    return { status: "error" };
  }
};

export { submitNewsletterForm, initNewsletterForms, initFooterNewsletterForm };
